module.exports = __webpack_public_path__ + "img/lv5_3_1.3ab7f073.png";